// src/components/Organizations.js

import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { AgGridReact } from 'ag-grid-react';
import Modal from 'react-modal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './OrganizationManager.css';
import OrganizationDialog from './OrganizationDialog';

const Organizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [currentOrg, setCurrentOrg] = useState(null);
  const [error, setError] = useState(null);
  const [fixedOrgType, setFixedOrgType] = useState(null);

  useEffect(() => {
    setCurrentOrg(null);
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      const response = await axiosInstance.get('organizations/');
      setOrganizations(response.data);
    } catch (error) {
      setError('Error fetching organizations');
    }
  };

  const openModal = (org = null, orgType = null) => {
    let _org = (org || { name: '', organization_type: 'Assay Provider' });
    setCurrentOrg(_org)
    setModalIsOpen(true);
    setFixedOrgType(orgType);
  };

  const cancelledModal = () => {
    closeModal();
  };

  const completedModal = () => {
    fetchOrganizations();
    closeModal();
  }

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentOrg(null);
  };

  const openDeleteModal = (org) => {
    setCurrentOrg(org);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setCurrentOrg(null);
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`organizations/${currentOrg.id}/`);
      fetchOrganizations();
      closeDeleteModal();
    } catch (error) {
      setError('Error deleting organization');
    }
  };

  const renderEditButton = (params) => (
    <button className="icon-button" onClick={() => openModal(params.data)}>
      <EditIcon />
    </button>
  );

  const renderDeleteButton = (params) => (
    <button className="icon-button" onClick={() => openDeleteModal(params.data)}>
      <DeleteIcon />
    </button>
  );

  const onRowDoubleClicked = (params) => {
    openModal(params.data);
  };

  const columns = [
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          {renderEditButton(params)}
          {renderDeleteButton(params)}
        </>
      ),
      width: 100,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' }
    },
    { headerName: "Name", field: "name", flex: 1 },
    // { headerName: "Description", field: "description", flex: 2 },
    { headerName: "Type", field: "organization_type", flex: 1 }
  ];

  return (
    <div className="organizations-container">
      <h1>Manage Organizations</h1>
      <button onClick={() => openModal(null)} className="add-organization-button">Add Organization</button>
      &nbsp;
      <button onClick={() => openModal(null, "Assay Provider")} className="add-organization-button">Add Assay Provider</button>
      {error && <div className="error-message">{error}</div>}
      <div
        className="ag-theme-alpine"
        style={{
          height: '400px',
          width: '80%',
          overflow: 'scroll'
        }}
      >
        <AgGridReact
          rowData={organizations}
          columnDefs={columns}
          domLayout="autoHeight"
          onRowDoubleClicked={onRowDoubleClicked}
          overlayNoRowsTemplate="."
        />
      </div>
      <OrganizationDialog
              open={modalIsOpen && (currentOrg != null)}    
              onClose={cancelledModal}
                inputEntity={currentOrg}
                onSubmit={completedModal}
                fixedType={fixedOrgType}

            />
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete the organization "{currentOrg && currentOrg.name}"?</p>
        <button onClick={handleDelete}>Yes, Delete</button>
        <button onClick={closeDeleteModal}>Cancel</button>
      </Modal>
    </div>
  );
};

export default Organizations;
